require('../../modules/es7.string.trim-right');
module.exports = require('../../modules/_core').String.trimRight;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/string/trim-end.js
// module id = 393
// module chunks = 17